import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email.validator';
import { InventoryService } from 'src/app/services/inventory.service';
import { RatePlanDTO } from 'src/app/models/RatePlanDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { StatusSimDTO } from 'src/app/models/StatusSimDTO.model';
import { CarrierDTO } from 'src/app/models/CarrierDTO.model';
import { carrierConstants } from 'src/app/shared/constants/carrierConstants';
import { DeviceFormComponent } from '../../devices/device-form/device-form.component';
declare var bootstrap: any;

@Component({
    selector: 'app-inventory-update',
    templateUrl: './inventory-update.component.html',
    styleUrl: './inventory-update.component.css',
    imports: [DeviceFormComponent]
})
export class InventoryUpdateComponent {

  @Input() simData: DeviceDTO = {} as DeviceDTO;



  idModule: number = 10;



  information: string = 'Update SIM / ICCID: ';


  devceID: string = '';
  isEditing: boolean = false;





  constructor(
    private route: ActivatedRoute,
    private router: Router

    //public permissionsService: ValidatePermissionsService,

  ) { }

  ngOnInit() {

    
    this.route.params.subscribe(params => {
      
      this.devceID = (params['id']); // Access the 'id' parameter from the URL
      if (this.devceID) {
        this.isEditing = true
      }
    });

    //this.permissionsService.validateAccessLevels(this.idModule);

    if (this.isEditing) {
      //this.simData = history.state.simData;
      this.information = this.information + this.devceID;
    }






  }





handleCreateUpdateResponse(event: string) {
  
   if (!event) {
window.history.back();
   }

}



  goBack() {
    window.history.back();
  }
































}
